const faq = {
  title: 'FAQ / Häufig gestellte Fragen',
  q1: {
    title: 'Wie funktioniert der Planen-Konfigurator?',
    toggle: 'kub-faq-accordion-q1',
    text: 'Ob als Abdeck-, Zelt-, Pool- oder LKW Plane: Mit dem Planen-Konfigurator von KUBULUS können Sie Ihre individuelle PVC Plane in höchster Qualität schnell, einfach und bequem in nur wenigen Schritten selbst konfigurieren:',
    steps: {
      form: {
        title: '1. Schritt',
        text: 'Wählen Sie die Form der PVC Plane und geben Sie die gewünschten Maße an.',
        id: 1
      },
      material: {
        title: '2. Schritt',
        text: 'Suchen Sie das Material, aus dem Ihre PVC Plane nach Maß bestehen soll, nach Gewebegewicht und Brandverhalten aus und geben Sie die gewünschte Farbe an.',
        id: 2
      },
      rand: {
        title: '3. Schritt',
        text: 'Gestalten Sie jede Randseite individuell mit Saum, Anzahl der Ösen, Hohlsaum, Keder, Hohlschnitt oder einfach nur einer Schnittkante – Sie haben die Wahl.',
        id: 3
      }
    },
    textVid: 'Eine Videoanleitung finden Sie'
  },
  q2: {
    title: 'Welche Gestaltungsmöglichkeiten bietet der Planen-Konfigurator?',
    toggle: 'kub-faq-accordion-q2',
    text: 'Grundsätzlich können Sie mit dem Planen-Konfigurator von KUBULUS sämtliche gängige Arten von PVC Planen mit individueller Randgestaltung gestalten - ganz nach Ihrem persönlichen Bedarf. Egal, ob Sie eine LKW Plane, ein Sonnensegel, eine Zeltplane oder eine Abdeckplane für Ihre Gartenmöbel, den Anhänger oder für den Carport oder etwas ganz anderes benötigen - mit unserem Tool kommen Sie Schritt für Schritt zu Ihrer individuellen <strong>PVC Plane nach Maß</strong>: einfach, bequem und schnell.'
  },
  q3: {
    title: 'Meine benötigte PVC Plane lässt sich nicht konfigurieren',
    toggle: 'kub-faq-accordion-q3',
    text: 'Wenn sich Ihre benötigte PVC Plane nicht konfigurieren lässt oder Sie Hilfe bei Ihrer Planen Maßanfertigung benötigen, können Sie gerne Kontakt zu uns aufnehmen. Wir helfen Ihnen gerne weiter und geben Ihnen bei Bedarf zusätzliche Informationen zu den unterschiedlichen PVC Materialien oder Randgestaltungsmöglichkeiten. Gemeinsam finden wir die passende PVC Plane für Ihr Vorhaben.',
    textTwo: 'Auf Wunsch schicken wir Ihnen vorab gerne ein <strong>kostenloses Muster</strong> zu.'
  },
  q4: {
    title: 'Warum eine PVC Plane online konfigurieren?',
    toggle: 'kub-faq-accordion-q4',
    text: 'Eine PVC Plane online zu konfigurieren hat mehrere Vorteile:',
    list: {
      one: {
        title: 'Einfache Handhabung',
        text: 'Eine PVC Plane zu konfigurieren ist nun einfacher denn je: Mit dem KUBULUS Planen-Konfigurator haben Sie die Möglichkeit Ihre neue PVC Plane in nur wenigen Schritten selbst zu konfigurieren. Zusätzlich finden Sie zu den Gestaltungsmöglichkeiten einfache Erklärungen zur Erleichterung der Auswahl.',
        id: 1
      },
      two: {
        title: 'Schnelle Auswahl',
        text: 'Sie wählen in dem KUBULUS Planen-Konfigurator die Form, das Material und die Farbe aus, gestalten den Rand nach Belieben mit Ösen, Keder, Hohlsaum, Hohlschnitt oder einer einfachen Schnittkante und schon können Sie Ihre neue PVC Plane bestellen. Nach Bestelleingang kümmern wir uns um Ihre neue PVC Plane. Wir konfektionieren und liefern Ihnen diese so schnell wie möglich - selbstverständlich in bester Qualität.',
        id: 2
      },
      three: {
        title: 'Bequeme Konfiguration von überall',
        text: 'Sie können Ihre neue PVC Plane nach Maß ganz bequem selbst konfigurieren, unabhängig von Zeit und Ort.',
        id: 3
      }
    }
  },
  q5: {
    title: 'Wie kann ich mir meine neue PVC Plane vorstellen?',
    toggle: 'kub-faq-accordion-q5',
    text: 'Damit Sie sich ganz einfach vorstellen können, wie Ihre selbst konfigurierte PVC Plane aussehen wird, bietet Ihnen der Planen-Konfigurator eine schematische Darstellung Ihrer Konfiguration, die sich anhand Ihrer Auswahl aktualisiert.',
    textTwo: 'Bei mobilen Endgeräten finden Sie die Darstellung immer über Ihrer aktuellen Auswahlfunktion.'
  },
  q6: {
    title: 'Auf welchen Endgeräten kann der Planen-Konfigurator bedient werden?',
    toggle: 'kub-faq-accordion-q6',
    text: 'Der Planen-Konfigurator von KUBULUS kann auf nahezu jedem Endgerät und über jeden aktuellen Browser bedient werden. Konfigurieren Sie Ihre PVC Plane bequem von zuhause oder unterwegs am Desktop, Laptop, Tablet oder Smartphone.',
    textTwo: 'Ihre Bestellung können Sie unabhängig von Zeit, Ort und Endgerät in unserem Planen-Konfigurator aufgeben.'
  },
  q7: {
    title: 'Wie unterscheiden sich die verschiedenen PVC Materialien?',
    toggle: 'kub-faq-accordion-q7',
    text: 'Die in unserem Planen-Konfigurator angebotenen PVC Materialien unterscheiden sich insbesondere in ihrem Gewebegewicht. Je höher das Gewebegewicht, desto reißfester, stabiler und schwerer ist die PVC Plane. Welches Gewebegewicht das passende für Ihre Planen Maßanfertigung ist, hängt von Ihrem individuellen Vorhaben ab.',
    textTwo: 'Weiter finden Sie in der Auswahl auch PVC Planen mit der Eigenschaft "schwer entflammbar nach DIN 4102 B1". Diese schwer entflammbaren PVC Planen sind insbesondere für Einsatzbereiche mit Publikumsverkehr, wie Veranstaltungen oder (gewerbliche) Innenräume, zwingend erforderlich.'
  },
  q8: {
    title: 'Warum eine Plane aus PVC?',
    toggle: 'kub-faq-accordion-q8',
    text: 'Die Vorteile von PVC gegenüber anderen Materialien liegen in der Langlebigkeit, UV-Stabilität, Temperaturbeständigkeit, Reißfestigkeit und Stabilität. Außerdem sind PVC Materialien formstabil, nicht dehnbar sowie luft- und wasserdicht.',
    textTwo: 'In unserem Planen-Konfigurator haben Sie die Wahl, Ihre PVC Plane nach Maß aus unterschiedlichen Gewebegewichten herstellen zu lassen.'
  }
}

export default {
  faq
}
